import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updateTemplate = async (templateID, options) => {
  const apiURL = API_HOST + '/templates/' + templateID;
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.patch(apiURL,{...options},{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
